import React from "react";
import { Switch, Redirect } from "react-router-dom";
import TopMenu from "Components/TopMenu/TopMenu";
import { superFinancialMenuItems } from "Constants/superFinancialMenuItems";
import SuperRoute from "hoc/Routes/SuperRoute/SuperRoute";
import Transactions from "./components/Transactions/Transactions";
import DefaultPanel from "./components/DefaultPanel/DefaultPanel";
import DefaultCharges from "./components/DefaultCharges/DefaultCharges";
import { useSelector } from "react-redux";
import { read } from "Helpers/LocalStorage";

export default function FinancialIndex() {
  const { isLoggedIn } = useSelector((state) => ({
    isLoggedIn: state.auth.isLoggedIn,
  }));
  let topMenuItems = [...superFinancialMenuItems];
  topMenuItems.map((item) => {
    if (item.menu_title === "defaultCharges") {
      item.active = !!read("FormDefaultCredit");
      return null;
    }
    if (item.menu_title === "defaultPanel") {
      item.active = !!read("FormDefaultPanel");
      return null;
    }
    if (item.menu_title === "transactions") {
      item.active = !!read("Financial");
      return null;
    }
  });

  return (
    <>
      <TopMenu menuItems={topMenuItems.filter((item) => item.active)} />
      <Switch>
        <Redirect
          exact
          from="/admin/financial"
          to={"/admin/financial/transactions"}
        />
        <SuperRoute
          exact
          path="/admin/financial/transactions"
          component={Transactions}
          isLoggedIn={isLoggedIn}
        />
        <SuperRoute
          exact
          path="/admin/financial/defaultPanel"
          component={DefaultPanel}
          isLoggedIn={isLoggedIn}
        />
        <SuperRoute
          exact
          path="/admin/financial/defaultCharges"
          component={DefaultCharges}
          isLoggedIn={isLoggedIn}
        />
      </Switch>
    </>
  );
}
